/**
 * How often a connected external account is checked for new data.
 *
 * One constant for both sides of the sync, not two independent guesses that could drift
 * apart. The server uses this to decide how often to call FatSecret and Apple Watch
 * (through Open Wearables) for new food or health readings; the client uses the same
 * value to decide how often to re-read what the server has, so a screen cannot lag the
 * server's own freshness by an extra poll cycle of its own.
 */
export const INTEGRATION_POLL_MS = 2.5 * 60_000;
